import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'header.modal.redirect.title',
    defaultMessage: 'Redirection Notice',
  },
  description: {
    id: 'header.modal.redirect.description',
    defaultMessage: 'You are now being redirected to another location site. To continue, click Next. To stay on current site, click Cancel.',
  },
  cancelBtn: {
    id: 'header.modal.redirect.btn.close',
    defaultMessage: 'Cancel',
  },
  submitBtn: {
    id: 'header.modal.redirect.btn.submit',
    defaultMessage: 'Next',
  },
});

export default messages;
